import {request, serviceUrl} from "@/utils/request";

//根据id获取实时告警数据
export function getAlarmRealTimeById(id) {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/getAlarmRealTimeById',
        params:{
            id
        },
    })
}

//获取告警级别以及对应总数
export function getLevelCount() {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/level-count'
    })
}

//获取最新的告警数据
export function getAlarmByCommitTimeAsc() {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/orderBy/commitTime/asc'
    })
}

// 获取告警列表
export function getInfo(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/real-time/list',
        data: params
    })
}

// 获取告警消息
export function getMsgList(params) {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/msgList',
        params: params
    })
}


// 批量告警处理
export function batchAlarmHandling(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/real-time/batch/alarm-handling',
        data: params
    })
}

// 告警处理
export function alarmHandling(params) {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/alarm-handling',
        params: params
    })
}

// 批量消警
export function batchAlarmElimination(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/real-time/batch/alarm-elimination',
        data: params
    })
}

// 消警
export function alarmElimination(params) {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/alarm-elimination',
        params: params
    })
}

// 获取设备告警信息
export function getListByDeviceId(deviceId) {
    return request({
        url: serviceUrl.deviceService + '/alarm/real-time/list-by/deviceId',
        params: {
            deviceId
        }
    })
}

// 获取告警列表文件
export function exportToExcel(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/real-time/export-excel',
        data: params,
        responseType: 'arraybuffer'
    })
}

// 时间格式化
export function dateFormat(date, format) {
    date = new Date(date);
    // date.setHours(date.getHours() - 14);
    var o = {
        'M+': date.getMonth() + 1, //month
        'd+': date.getDate(), //day
        'H+': date.getHours(), //hour
        'm+': date.getMinutes(), //minute
        's+': date.getSeconds(), //second
        'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
        'S': date.getMilliseconds() //millisecond
    };

    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

    for (var k in o)
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    return format;
}

// 数组去重
export function unique(arr) {
    // 如果新数组的当前元素的索引值 == 该元素在原始数组中的第一个索引，则返回当前元素
    return arr.filter(function (item, index) {
        return arr.indexOf(item, 0) === index;
    });
}


//获取实时告警总数
export function alarmRealTimeTotal() {
  return request({
    url: serviceUrl.deviceService + '/alarm/real-time/total'
  })
}


//获取机房告警标识
export function getSpaceAlarmIds() {
  return request({
    url: serviceUrl.deviceService + '/alarm/real-time/space-alarm-ids'
  })
}
